export const appAccelAppID = 'add_app_accl';

// RN Only licenses can't do the ADEM testing
export const rnOnlyLicenseTypes = ['NETACCESSAPPACCLPAE'];
